import { useEffect, useRef } from "react";
import { useControlContext } from "../../../control";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { selectChatId, selectInputMessage } from "../../selectors";
import { postEventUserTyping } from "../../actions";

export const useUserTyping = () => {
  const { api } = useControlContext();
  const chatId = useAppSelector(selectChatId);
  const dispatch = useAppDispatch();
  const message = useAppSelector(selectInputMessage);
  const messagePrev = useRef("");
  const messageCurrent = useRef("");
  const { postEventApi } = api;
  const postEventParams = { postEventApi };

  const handleUserTyping = () => {
    if (chatId) {
      dispatch(postEventUserTyping(postEventParams));
    }
  };

  useEffect(() => {
    messageCurrent.current = message.text;
  }, [message.text]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (
        messageCurrent.current &&
        messageCurrent.current !== messagePrev.current
      ) {
        handleUserTyping();

        messagePrev.current = messageCurrent.current;
      }
    }, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, [chatId]);
};
